import { SalesOrder, Picking, SalesOrderModel, ShippingModel, Shipping, ShippingItem, SalesOrderSearch, SalesOrderItem, GenerateNewDONO, CancelSalesOrderModel } from './../model/shipping.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { User } from "../model/user.model";
import { PackingSalesOrderSearch, Packing4SalesOrderResult } from "../model/shipping.model";


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class ShippingService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/SaleOrder';
    }

    CancelSalesOrder(search: CancelSalesOrderModel): Observable<any> {
        return this.http.post<any>(this.Url + '/CancelSalesOrder/', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }



    GetPacking4SalesOrder(search: PackingSalesOrderSearch): Observable<Packing4SalesOrderResult[]> {
        return this.http.post<Packing4SalesOrderResult[]>(this.Url + "/GetPacking4SalesOrder", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getSaleOrderList(): Observable<SalesOrder[]> {
        return this.http.get<SalesOrder[]>(this.Url + '/GetSaleOrderList', httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    getSaleOrderLists(search: SalesOrderSearch): Observable<SalesOrder[]> {
        return this.http.post<SalesOrder[]>(this.Url + "/GetSaleOrderList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    AddSaleOrder(search: SalesOrderModel): Observable<any> {
        return this.http.post<any>(this.Url + "/AddSaleOrder", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetSaleOrderById(id: number): Observable<SalesOrderModel> {
        return this.http.get<SalesOrderModel>(this.Url + "/" + id.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GenerateNewDONO(item: SalesOrderItem): Observable<GenerateNewDONO> {
        return this.http.post<GenerateNewDONO>(this.Url + "/GenerateNewDONO", item, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetStockItems4Picking(SONo: string): Observable<Array<Picking>> {
        return this.http.get<Array<Picking>>(this.Url + "/GetStockItems4Picking/" + SONo, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    AddPicking(data: Array<Picking>): Observable<any> {
        return this.http.post<any>(this.Url + "/AddPicking", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    DeletePicking(data: Picking): Observable<any> {
        return this.http.post<any>(this.Url + "/DeletePicking", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    GetPickingList(data: Picking): Observable<any> {
        return this.http.post<any>(this.Url + "/GetPickingList", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }


    GetPickingDetail(data: Picking): Observable<any> {
        return this.http.post<any>(this.Url + "/GetPickingDetail", data, httpOptions)
            .pipe(
                tap(response => { })
            );
    }

    AddShipping(search: ShippingModel): Observable<any> {
        return this.http.post<any>(this.Url + "/AddShipping", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GetPicking4Shipping(search: Shipping): Observable<Array<ShippingItem>> {
        return this.http.post<Array<ShippingItem>>(this.Url + "/GetPicking4Shipping", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    GetShippingList(search: Shipping): Observable<Array<ShippingModel>> {
        return this.http.post<Array<ShippingModel>>(this.Url + "/GetShippingList", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }


    CancelShipping(search: Shipping): Observable<any> {
        return this.http.post<any>(this.Url + "/CancelShipping", search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }

    GenerateShippingBarcodePDF(data: number): Observable<any> {
        return this.http.get(this.Url + "/GetShippingLabelPDF/" + data.toString(), {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            responseType: 'arraybuffer',
        }).pipe(tap((x) => {
            console.log(x);
        }),
        );
    }

    ShippingExcel(s: number): Observable<any> {

        return this.http.post(this.Url + '/ShippingExcel/' + s, null, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<{}>('SearchWorkPermit'))
        );
    }

    GetSaleOrderForExport(search: SalesOrderSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetSaleOrderForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',

            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<{}>('SearchWorkPermit'))
        );
    }

    /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }







}


// WEBPACK FOOTER //
// ./src/app/services/shipping.service.ts